<template>
  <div></div>
</template>

<script>
import confetti from "canvas-confetti";

export default {
  name: "Confetti",
  props: {
    // Confetti configuration props
    spread: {
      type: Number,
      default: 360
    },
    angle: {
      type: Number,
      default: 90
    },
    ticks: {
      type: Number,
      default: 100
    },
    gravity: {
      type: Number,
      default: 0.4
    },
    decay: {
      type: Number,
      default: 0.9
    },
    startVelocity: {
      type: Number,
      default: 33
    },
    colors: {
      type: Array,
      default: () => ["FFE400", "FFBD00", "E89400", "FFCA6C", "FDFFB8"]
    },
    originY: {
      type: Number,
      default: 0.4
    },
    originX: {
      type: Number,
      default: 0.5
    },
    zIndex: {
      type: Number,
      default: 10000
    },
    // Particle configuration
    particleCount1: {
      type: Number,
      default: 200
    },
    scalar1: {
      type: Number,
      default: 1.8
    },
    shapes1: {
      type: Array,
      default: () => ["square"]
    },
    particleCount2: {
      type: Number,
      default: 100
    },
    scalar2: {
      type: Number,
      default: 0.95
    },
    shapes2: {
      type: Array,
      default: () => ["circle"]
    },
    // Timing configuration
    delays: {
      type: Array,
      default: () => [0]
    }
  },
  methods: {
    /**
     * Trigger the confetti celebration
     */
    celebrate() {
      console.log("Confetti celebration triggered");

      const defaults = {
        spread: this.spread, // Range: 0-360 degrees. How wide the confetti spreads (0=narrow, 360=full circle)
        angle: this.angle, // Range: 0-360 degrees. Launch direction (90=straight up, 0=right, 180=left, 270=down)
        ticks: this.ticks, // Range: 1-1000+. Animation duration in frames (higher=longer visible, ~200=2sec at 60fps)
        gravity: this.gravity, // Range: 0-2+. Downward pull strength (0=float forever, 1=normal gravity, 2=heavy fall)
        decay: this.decay, // Range: 0-1. Speed retention over time (0.9=lose speed quickly, 0.99=maintain speed longer)
        startVelocity: this.startVelocity, // Range: 1-100+. Initial launch speed in pixels (higher=travels further)
        colors: this.colors, // Array of hex colors (with or without #)
        origin: {
          x: this.originX, // Range: 0-1. Horizontal launch position (0=left, 0.5=center, 1=right)
          y: this.originY // Range: 0-1. Vertical launch position (0=top, 0.5=middle, 1=bottom)
        },
        zIndex: this.zIndex // Range: 0-999999. CSS z-index for layering (higher=more on top)
      };

      const shoot = () => {
        // First confetti burst
        confetti({
          ...defaults,
          angle: 0,
          particleCount: this.particleCount1, // Range: 1-500+. Number of confetti particles (more=denser, 50-150 typical)
          scalar: this.scalar1, // Range: 0.1-3+. Size multiplier (1=normal, 0.5=half size, 2=double size)
          shapes: this.shapes1 // Options: "square", "circle", "star", or custom shapes
        });

        confetti({
          ...defaults,
          angle: 180,
          particleCount: this.particleCount1, // Range: 1-500+. Number of confetti particles (more=denser, 50-150 typical)
          scalar: this.scalar1, // Range: 0.1-3+. Size multiplier (1=normal, 0.5=half size, 2=double size)
          shapes: this.shapes1 // Options: "square", "circle", "star", or custom shapes
        });

        // Second confetti burst
        confetti({
          ...defaults,
          particleCount: this.particleCount2, // Range: 1-500+. Number of confetti particles (more=denser, 50-150 typical)
          scalar: this.scalar2, // Range: 0.1-3+. Size multiplier (1=normal, 0.5=half size, 2=double size)
          shapes: this.shapes2 // Options: "square", "circle", "star", or custom shapes
        });
      };

      // Execute confetti with specified delays
      this.delays.forEach(delay => {
        setTimeout(shoot, delay);
      });

      // Emit event for parent components
      this.$emit("celebration-complete");
    },

    /**
     * Stop all confetti animations
     */
    stop() {
      confetti.reset();
      this.$emit("celebration-stopped");
    }
  }
};
</script>

<style scoped>
/* No visual styles needed - this component handles confetti via canvas */
</style>
